import axios from 'axios';
import Dialog from '../components/Dialog.vue';
import Snackbar from '../components/Snackbar.vue';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'Download',
    inject: ['checkUrl', 'mapUrl'],
    components: {
        Snackbar,
        Dialog
    },
    data() {
        return {
            errorMse: ''
        };
    },
    computed: {
        ...mapState('auth', ['isLogin']),
        ...mapState('news', ['sourceTargetKey'])
    },
    mounted() {
        this.toDownload();
    },
    methods: {
        ...mapActions('message', ['setSnackbar']),
        toDownload() {
            this.errorMse = '';
            const query = this.$route.query;
            const fileClass = query.fileClass;
            if (!query.fileName || !fileClass) {
                window.close();
                return;
            }
            if (['source'].includes(fileClass) && !this.isLogin) {
                this.setSnackbar({
                    show: true,
                    text: 'LOGINERROR_1',
                    timeout: 1800
                });
                this.$router.push({
                    path: '/'
                });
                return;
            }
            const url = this.mapUrl(query.fileName, fileClass);
            this.$nextTick(function () {
                // if (!this.checkUrl(url)) {
                //   this.errorMse = '很抱歉下载失败，请与客服人员联系。'
                //   // this.setSnackbar({
                //   //   show: true,
                //   //   text: 'NO DATA',
                //   //   type: 'text',
                //   //   timeout: 1800
                //   // })
                //   // this.$router.push({
                //   //   path: '/'
                //   // })
                //   return
                // }
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', query.fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.setTimeout(function () {
                        window.close();
                    }, 1000);
                });
            });
        }
    }
};
